// src/redux/reducers/rootReducer.js
import { combineReducers } from "redux";
import authReducer from "./authReducer";
import profileReducer from "./profileReducer";
import {attendanceReducer}  from "./attendanceReducer";
import { taskReducer } from "./taskReducer";
import { attendanceReportReducer } from "./AttendanceReportReducer";
import leaveReducer from "./leaveReducer";


const rootReducer = combineReducers({
  auth: authReducer,
  profile: profileReducer,
  attendance: attendanceReducer, 
   task: taskReducer,
    attendanceReport: attendanceReportReducer, 
    leave: leaveReducer,
});

export default rootReducer;
